import { useQuery } from 'react-query';
import {
  fetchUnidades,
  fetchIdContabeis,
  fetchTipoItem,
  fetchDepartamentos,
  fetchTiposDeAjustes,
  fetchVasilhames,
  fetchPisCofins,
  fetchTributacoesEntrada,
  fetchTributacoesSaida,
} from '../services';

const defaultConfig = {
  staleTime: 1000 * 60 * 5,
  cacheTime: 1000 * 60 * 10,
};

export function useProdutoQueries() {
  const unidades = useQuery(['unidades'], fetchUnidades, defaultConfig);
  const idContabeis = useQuery(
    ['id-contabeis'],
    fetchIdContabeis,
    defaultConfig,
  );
  const tipoItem = useQuery(['tipo-item'], fetchTipoItem, defaultConfig);
  const departamentos = useQuery(
    ['departamentos'],
    fetchDepartamentos,
    defaultConfig,
  );
  const tiposDeAjuste = useQuery(
    ['tipos-ajuste'],
    fetchTiposDeAjustes,
    defaultConfig,
  );
  const vasilhames = useQuery(['vasilhames'], fetchVasilhames, defaultConfig);
  const pisCofins = useQuery(
    ['optionsPisCofins'],
    fetchPisCofins,
    defaultConfig,
  );
  const tribEntrada = useQuery(
    ['tributacoesEntrada'],
    fetchTributacoesEntrada,
    defaultConfig,
  );
  const tribSaida = useQuery(
    ['tributacoesSaida'],
    fetchTributacoesSaida,
    defaultConfig,
  );

  return {
    unidades,
    idContabeis,
    tipoItem,
    departamentos,
    tiposDeAjuste,
    vasilhames,
    pisCofins,
    tribEntrada,
    tribSaida,
  };
}
